// Sidebar Routers
export const menus = {
  'Dashboard': [
    {
      action: 'zmdi-view-dashboard',
      title: 'Temel Istatistik',
      active: false,
      items: null,
      path: '/dashboard/',
      label:'Old'
    }
  ],
  'Ilan Yönetimi': [
    {
      action: 'ti-bookmark-alt',
      title: 'Ilan Listesi',
      active: false,
      items: null,
      path: '/bids',
      label:'Old'
    },
    {
      action: 'ti-check',
      title: 'Yorumlar',
      active: false,
      items: null,
      path: '/comments',
      label:'Old'
    },
  ],
  'Finans': [
    {
      action: 'zmdi-store-24',
      title: 'Bankalar',
      active: false,
      items: null,
      path: '/finance/banks',
      label:'Old'
    },
    {
      action: 'zmdi-mall',
      title: 'Masraf',
      active: false,
      items: [
        {
          action: 'zmdi-store-24',
          title: 'Kodlar',
          active: false,
          items: null,
          path: '/finance/expenseCodes',
          label:'Old'
        },
        {
          action: 'zmdi-store-24',
          title: 'Kayıtlar',
          active: false,
          items: null,
          path: '/finance/expenseRecords',
          label:'Old'
        },
      ],
      path: '',
      label:'Old'
    },
    {
      action: 'zmdi-store',
      title: 'Gelir & Giderler',
      active: false,
      items: null,
      path: '/finance/transactions',
      label:'Old'
    },
    {
      action: 'zmdi-file-text',
      title: 'Faturalar',
      active: false,
      items: null,
      path: '/finance/invoices',
      label:'Old'
    },
    {
      action: 'zmdi-money-box',
      title: 'Ödemeler',
      active: false,
      items: [
        {
          action: 'ti-credit-card',
          title: 'Kredi Karti Ödemeleri',
          active: false,
          items: null,
          path: '/finance/payments',
          label:'Old'
        },
        {
          action: 'zmdi-store-24',
          title: 'EFT Bildirileri',
          active: false,
          items: null,
          path: '/finance/eft-reports',
          label:'Old'
        },
        {
          action: 'zmdi-store-24',
          title: 'Borçlu Listesi',
          active: false,
          items: null,
          path: '/finance/debtList',
          label:'Old'
        },
        {
          action: 'zmdi-store-24',
          title: 'Hatalı Ödemeler',
          active: false,
          items: null,
          path: '/finance/failedPayments',
          label:'Old'
        },
      ],
      path: '/finance/transactions',
      label:'Old'
    },
  ],
  'Destek': [
    {
      action: 'ti-headphone-alt',
      title: 'Müşteri Destek Paneli',
      active: false,
      items: null,
      path: '/support/index',
      label:'Old'
    }
  ],
  'Kullanıcılar': [
    {
      action: 'ti-user',
      title: 'Normal',
      active: false,
      items: null,
      path: '/users/normal',
      label:'Old'
    },
    {
      action: 'ti-briefcase',
      title: 'Şirket',
      active: false,
      items: null,
      path: '/users/company',
      label:'Old'
    },
    {
      action: 'ti-truck',
      title: 'Nakliye',
      active: false,
      items: null,
      path: '/users/transporter',
      label:'Old'
    },
    {
      action: 'ti-check',
      title: 'Onay Bekleyenler',
      active: false,
      items: null,
      path: '/users/pending',
      label:'Old'
    },
    {
      action: 'ti-na',
      title: 'Yasaklananlar',
      active: false,
      items: null,
      path: '/users/blocked',
      label:'Old'
    },
    {
      action: 'ti-check-box',
      title: 'Hakkinda Onaylari',
      active: false,
      items: null,
      path: '/users/pending-about',
      label:'Old'
    },
    {
      action: 'ti-receipt',
      title: 'Eksik Evraklar',
      active: false,
      items: null,
      path: '/users/missingDocuments',
      label:'Old'
    }
  ],
  'Sayfalar': [
    {
      action: 'ti-layout-media-left',
      title: 'Kurumsal Sayfalar',
      active: false,
      items: null,
      path: '/pages/page',
      label:'Old'
    },
    {
      action: 'ti-view-list-alt',
      title: 'Yardım',
      active: false,
      items: null,
      path: '/pages/helps',
      label:'Old'
    },
    {
      action: 'ti-layout-cta-btn-left',
      title: 'Blog',
      active: false,
      items: null,
      path: '/pages/blogs',
      label:'Old'
    },
  ],
}
